// @flow

import * as React from "react";
import { Link } from "react-router-dom";
import { route } from "@routes/helper";
import classNames from "classnames";
import { TooltipDropdown } from "@components";
import type { StatItemProps } from "./types";

import "./stat-item.style.scss";

export const StatItem = ({
  valueClass = "",
  titleClass = "",
  valueContainerClass = "",
  itemClassName = "",
  ...props
}: StatItemProps) => {
  const isLongValue = typeof props.value === "string" && props.value.length > 50;
  const value = (
    <div
      className={classNames("d-flex align-items-center", {
        [valueContainerClass]: valueContainerClass,
      })}
    >
      {props.icon}
      <span
        className={classNames("ml-2", {
          [valueClass]: valueClass,
          "font-size-20": isLongValue,
          "pl-3 pt-1": props.icon,
        })}
      >
        {props.value}
        {props.prefix && <span className="font-size-25">{props.prefix}</span>}
      </span>
    </div>
  );

  return (
    <div
      onClick={props.onClick}
      className={classNames("stat-item mt-3 pt-2", {
        [itemClassName]: itemClassName,
        "cursor-pointer": props.onClick,
      })}
    >
      <div
        className={classNames("stat-title mb-2", {
          [titleClass]: titleClass,
        })}
      >
        {props.title}
        {props.additionToTitle && <span className="text-orange mr-2">{props.additionToTitle}</span>}
        {props.titleTooltip && (
          <TooltipDropdown
            description={props.titleTooltip.description}
            title={props.titleTooltip.title || props.title}
            id={props.titleTooltip.id}
            size={"medium"}
          />
        )}
      </div>
      {props.path ? <Link to={route(props.path, props.pathOptions)}>{value}</Link> : value}
    </div>
  );
};

export default StatItem;
